var MemberView = Backbone.View.extend({
    tagName: 'li',
    className: 'user',
    initialize: function (options) {
        this.formatter = options.formatter;
        this.model.bind('change:nick', this.remove, this);
        this.model.bind('change:display_name', this.renderLink, this);
        this.model.bind('change:usermask', this.renderLink, this);
        this.model.bind('change:realname', this.renderLink, this);
        this.model.bind('change:away', this.renderLink, this);
        this.model.bind('remove', this.remove, this);
        this.model.collection.bind('reset', this.remove, this);
        if (this.model.channel) {
            this.listenTo(this.model.channel, 'preinit', this.remove);
        }
    },
    getLinkClassName: function () {
        var className = 'link buffer bufferLink user ' + this.model.getModeClass();
        if (this.model.isAway()) {
            className += ' away';
        } else {
            className += ' present';
        }
        if (!this.model.isSelf()) {
            var index = this.formatter.getNickColorIndex(this.model.getName());
            className += ' c' + index;
        }
        return className;
    },
    remove: function () {
        return Backbone.View.prototype.remove.apply(this, arguments);
    },
    renderLink: function () {
        this.$el.toggleClass('away', this.model.isAway());
        this.$el.toggleClass('present', !this.model.isAway());
        var name = this.model.getDisplayAuthor() || this.model.getName();
        this.link.text(name);
        this.link.removeClass();
        this.link.addClass(this.getLinkClassName());
        this.link.attr({
            'aria-controls': 'memberContextMenu',
            'aria-haspopup': 'true'
        });
        var title = this.model.getTitle();
        if (title) {
            this.link.attr('title', title);
        }
        if (this.model.channel) {
            this.$el.attr('data-bid', this.model.channel.bid());
        }
        this.$el.attr('data-cid', this.model.getCid());
        this.$el.attr('data-name', this.model.getName());
        this.$el.attr('data-usermask', this.model.getHostMask());
        this.$el.attr('data-ident_prefix', this.model.get('ident_prefix'));
        this.$el.attr('data-user', this.model.get('user'));
        this.$el.attr('data-userhost', this.model.get('userhost'));
        this.$el.attr('data-mode', this.model.get('mode'));
        this.link.attr('data-cid', this.model.getCid());
        this.link.attr('data-name', this.model.getName());
        this.link.attr('data-usermask', this.model.getHostMask());
        this.link.attr('data-ident_prefix', this.model.get('ident_prefix'));
        this.link.attr('data-user', this.model.get('user'));
        this.link.attr('data-userhost', this.model.get('userhost'));
        this.link.attr('data-mode', this.model.get('mode'));
        return this;
    },
    render: function () {
        this.link = $('<button>');
        this.renderLink();
        this.$el.append(this.link);
        return this;
    }
});


module.exports = MemberView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/memberview.js
// module id = IJ5v
// module chunks = 1